import React from 'react';
import ReactDOM from 'react-dom/client';
import './c_c1f535336b.css';
import A1b2c3x from './a1b2c3x';
import {BrowserRouter as Router} from 'react-router-dom';
import {Routes, Route} from "react-router-dom";
import R4c8zr from './serco/r4c8zr';
import M8ge3r from './serco/m8ge3r';
import Zr7mx2 from './serco/zr7mx2';
import C9r2wq from './serco/c9r2wq';
import H5z9n1 from './serco/h5z9n1';
import W0qx7t from './serco/w0qx7t';
import V3w4x5r from './v3w4x5r';

const bluchis = ReactDOM.createRoot(document.getElementById('root'));
const magrass = ReactDOM.createRoot(document.getElementById('bluchis'));
const gitmonkey = ReactDOM.createRoot(document.getElementById('gitmonkey'));

bluchis.render(
  <React.StrictMode>
    <Router>
      <Routes> 

  <Route path="/X7mQK9T5P4R8FZJ2yB6V1N0CwL3UHsDkGgSxWqMvo6V1N0CwL3U" element={<R4c8zr />} />
  <Route path="/B9W2ZQJX6yC0SgL5T8V4M7P1kHNFDRU3wvoKRxX6yC0Sgm" element={<M8ge3r />} />
  <Route path="/QZP4y1W6N0B2kM7C9x8H5SFRLVTJDgU3wvoKH5SFRLVJDg" element={<Zr7mx2 />} />
  <Route path="/K8X4R2C6WZQ7T5yS9P1H0MNBJFDV3LgUwvokV3LgUwvqbs" element={<C9r2wq />} />
  <Route path="/ZJ7Q9C8V0k1H5T2yW4B6PXRMSF3DNLgUwvyW4B7C9J7Q9x" element={<H5z9n1 />} />
  <Route path="/P2X7QZ6T8W0yK9C4R1M5BHDJFSV3NULgwo9C4R1M5BHDrb" element={<W0qx7t />} />

      </Routes>
    </Router>
  </React.StrictMode>
);

if (magrass) {
  magrass.render(
    <React.StrictMode>
      <Router>
        <Routes> 
          <Route path="/" element={<A1b2c3x />} />
           <Route path="/a1b2c3x" element={<A1b2c3x />} />
        </Routes>
      </Router>
    </React.StrictMode>
  );
}

if (gitmonkey) {
  gitmonkey.render(
    <React.StrictMode>
      <Router>
        <Routes> 
        <Route path="/abv" element={<ab />} />
        </Routes>
      </Router>
    </React.StrictMode>
  );
}
V3w4x5r();